import moment from "moment"

export const handleRecords = (records) => {
  const nextWeek = []
  const recentEvents = []

  records.forEach(function(record) {
    const eventCreate= moment(record.fields['Created time'])
    const eventStart =  moment(record.fields['Start time'])
    if( eventCreate.isBetween(moment().subtract(7, "d"), moment())) {
      recentEvents.push(record)
    }
    if(eventStart.isBetween(moment(), moment().add(7, "d"))) {
      nextWeek.push(record)
    }
  });
  return {
    nextWeek,
    recentEvents
  }
}


// WEBPACK FOOTER //
// ./src/components/Main/records.js